import { render, staticRenderFns } from "./PrinterConfig.yaml?vue&type=template&id=03478588&component"
import script from "./PrinterConfig.yaml?vue&type=script&lang=ts&component"
export * from "./PrinterConfig.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports